import React, { ReactElement, use } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import { Navigate } from 'react-router';
import { AppContext, AppContextData } from '../utils/context';
import { LinkContainer } from './link_container';

export enum LoginState {
    LoggedIn = 1,
    LoggedOut = 2,
    Admin = 3,
}

interface CustomRouteHandlerOptions {
    readonly login?: LoginState;
    readonly children?: ReactElement;
}
export const CustomRouteHandler: React.FC<CustomRouteHandlerOptions> = ({ login, children }) => {
    const { userLoaded, user } = use(AppContext);

    let component: ReactElement = <p>Loading...</p>;
    if (userLoaded) {
        if (!user && login === LoginState.LoggedIn) {
            component = <Navigate to="/login" />;
        } else if ((user && login === LoginState.LoggedOut) || (!user?.admin && login === LoginState.Admin)) {
            component = <Navigate to="/" />;
        } else if (children) {
            component = children;
        }
    }

    return component;
};

function shouldRender(login: LoginState | undefined, context: AppContextData) {
    if (!login) {
        return true;
    }

    if (!context.userLoaded) {
        return false;
    }

    if (login === LoginState.LoggedIn && !context.user) {
        return false;
    }

    if (login === LoginState.LoggedOut && context.user) {
        return false;
    }

    if (login === LoginState.Admin && !context.user?.admin) {
        return false;
    }

    return true;
}

interface CustomNavLinkOptions {
    readonly to: string;
    readonly login?: LoginState;
    readonly children?: ReactElement;
}
export const CustomNavLink: React.FC<CustomNavLinkOptions> = ({ to, login, children }) => {
    const context = use(AppContext);
    if (!shouldRender(login, context)) {
        return null;
    }

    return (
        <LinkContainer to={to}>
            <Nav.Link active={false}>{children}</Nav.Link>
        </LinkContainer>
    );
};

export const CustomDropDownItem: React.FC<CustomNavLinkOptions> = ({ to, login, children }) => {
    const context = use(AppContext);
    if (!shouldRender(login, context)) {
        return null;
    }

    return (
        <LinkContainer to={to}>
            <Dropdown.Item>{children}</Dropdown.Item>
        </LinkContainer>
    );
};
